// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Function to safely render the app
function renderApp() {
  try {
    const rootElement = document.getElementById('root');
    
    if (!rootElement) {
      throw new Error('Root element not found');
    }

    const root = ReactDOM.createRoot(rootElement);

    // Render without React.StrictMode
    root.render(
      <App />
    );

  } catch (error) {
    console.error('Failed to initialize React application:', error);
    document.getElementById('root').innerHTML = `
      <div style="color: white; padding: 20px;">
        Failed to initialize application
        <pre style="color: red; margin-top: 10px;">${error.stack}</pre>
      </div>
    `;
  }
}

// Wrap in a setTimeout to ensure DOM is ready
setTimeout(renderApp, 0);

// Add global error handler
window.onerror = function(message, source, line, column, error) {
  console.error('Global error:', { message, source, line, column, error });
  return false;
};
